module.exports = __webpack_public_path__ + "images/st-screen-icon-5c061911.svg";